import type { FaireProductEntity } from "../../entity_types/product";

export const p_qmugvp9ke7: FaireProductEntity = {
  token: "p_qmugvp9ke7",
  type: "product",
  name: "Minimalist Oval Gold Pendant Necklace",
  brandToken: "b_tstkerjyhp",
  brandName: "Merveille",
  imageUrl:
    "https://cdn.faire.com/fastly/a3f0366939fca8ab867204a9821a726456f7086e5c54b694a9916673ffd1ee9b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/63775efc8856f7132c14657e974b7aac19c889d9e9457cd0e1591caace49cd16.jpeg",
  ],
  priceDollars: 12.12,
  description:
    'A sleek minimalist necklace featuring a smooth oval gold pendant that offers a clean and modern look. The simple silhouette makes it a versatile accessory that pairs effortlessly with everyday outfits or layered jewelry styling. Lightweight and elegant, this necklace adds a subtle touch of sophistication to any jewelry collection. A timeless boutique piece perfect for customers who love classic minimalist fashion.\nNecklace Length : 16" with 3" Extender\n\nFeatures\n• Smooth oval pendant design\n• Minimalist and modern style\n• Lightweight and comfortable to wear\n• Perfect for layering or everyday styling\n• Timeless boutique fashion jewelry\n\noval pendant necklace, minimalist gold necklace, simple pendant necklace, modern minimalist jewelry, gold oval necklace, dainty pendant necklace, everyday gold necklace, boutique fashion necklace, classic pendant jewelry, layering necklace, elegant minimalist necklace, trendy boutique jewelry, women fashion necklace, timeless gold pendant, stylish minimal jewelry',
  tags: [],
  msrpDollars: 24.25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:55.897Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
